var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#User_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.333,
    height: 33.333,
    x: 3.333,
    y: 3.333,
    fill: "#DCDFE7",
    rx: 16.667
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#979BA9",
    d: "M20 24.167c7.364 0 13.333 5.97 13.333 13.334S27.363 50.834 20 50.834 6.667 44.864 6.667 37.5 12.637 24.167 20 24.167m0-15.833a6.667 6.667 0 1 1 0 13.334 6.667 6.667 0 0 1 0-13.334"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "User_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.333,
    height: 33.333,
    x: 3.333,
    y: 3.333,
    fill: "#fff",
    rx: 16.667
  })))));
};
export default SvgUser;